import { BaseBackupPlan } from 'wizards/models/base/base-backup-plan-model';
import { DiskInfoCommunication } from 'wizards/models/base/base-models/plan-disk-info-model';
import { BaseRetentionPolicy, GFSPolicySettings } from 'wizards/models/retention-policy-models';
import { ScheduleSettings } from 'wizards/models/schedule-advanced-models';
import { BackupTargetVolumesEnum } from 'wizards/models/what-backup-models';

export class BackupDiskImagePlan extends BaseBackupPlan {
  public CopyBufferSize: number;
  public BackupVolumes: BackupTargetVolumesEnum;
  public IsPlanCanBeRunnedWithoutLicense: boolean;
  public IsSyntheticSupported: boolean;
  public UsePersistentVss: boolean;
  public VSSProviderID: string;
  public IgnoreReadingBeyondTheEndOfTheDisk: boolean;
  public IgnoreBadSectors: boolean;
  public BlockSize: number;
  public PrefetchBlockCount: number;
  public DisableDASDIO: boolean;
  public DisableVSS: boolean;
  public DiskInfo: DiskInfoCommunication[] = [];
  public ForceFullDiffSizeCondition: number;
  public ForceFullApplyDiffSizeCondition: boolean;
  public ForceFullSchedule: ScheduleSettings;
  public UseFullSchedule: boolean;
  public UseDifferentialUpload: boolean;
  public ExcludeEnabled: boolean;
  public AlwaysUseVSS?: boolean;
  public UseFullConsistencyCheck?: boolean;
  public HideDeleteFilesWarning?: boolean;
  public SaveDeletedDataInCloud?: boolean;
  public UseFileNameEncryption?: boolean;
  public HybridRetentionPolicy?: BaseRetentionPolicy;
  public GFSPolicySettings?: GFSPolicySettings;
  public BackupOnlyModifiedDaysAgo?: string;
  public Hint?: string;
  public MaxFileSize?: number;

  static Guid_DirectAccessVSS = 'b5946137-7b9f-4925-af80-51abd60b20d5';

  constructor() {
    super();
  }
}
